export default __webpack_public_path__ + "static/farming-first-78b0310c2cffefe942e2fc3d53ff934d.svg";